export const navLinks = [
  { label: '今日热榜', href: '#hot' },
  { label: '场景选线', href: '#scenario' },
  { label: '线路对比', href: '#compare' },
  { label: '速度测试', href: '#speed' },
  { label: '切换指南', href: '#guide' },
];

export const ticker = [
  { text: '晚间高峰 · 亚太节点 13ms', tag: '状态' },
  { text: '跨境通道延迟回落 9%', tag: '波动' },
  { text: '新上「星野中转」支持一键切换', tag: '更新' },
  { text: '多线选择指南已同步最新样本', tag: '指引' },
  { text: '测速参考基准已刷新至本周', tag: '数据' },
];

export const hotTopics = [
  { label: '高峰时段突然卡顿怎么办', heat: '9.6万' },
  { label: '白天跨境比晚上快', heat: '8.4万' },
  { label: '校园网绕行的小技巧', heat: '7.9万' },
  { label: '延迟 40ms 是不是掉链了', heat: '7.2万' },
  { label: '怎么判断当前线路到底哪个好用', heat: '6.8万' },
  { label: '多线切换时到底会不会断', heat: '6.1万' },
  { label: '本地网络和远程机房选谁', heat: '5.6万' },
  { label: '换了线路还是慢 先查这三处', heat: '5.1万' },
  { label: '凌晨四点 全路线路都空', heat: '4.6万' },
  { label: '跨省延迟 为啥忽高忽低', heat: '4.2万' },
];

export const topLines = [
  { rank: 1, name: '云岫 · 国内干线', tag: '稳', heat: '12.8万', up: '98.6%', move: '→', best: true },
  { rank: 2, name: '星野 · 亚太', tag: '快', heat: '11.4万', up: '97.9%', move: '↑2', best: false },
  { rank: 3, name: '长桥 · 北美', tag: '新', heat: '9.7万', up: '96.8%', move: '↑1', best: false },
  { rank: 4, name: '疾风 · 跨境中转', tag: '热', heat: '8.9万', up: '95.4%', move: '↓1', best: false },
  { rank: 5, name: '雪雀 · 欧洲纵深', tag: '准', heat: '7.3万', up: '94.1%', move: '→', best: false },
];

export const scenarios = [
  {
    id: 1,
    icon: 'ri-signal-wifi-line',
    title: '蜂窝与移动网络',
    tip: '多线选择优先看“弱信号稳定”',
    desc: '地铁、通勤、户外上网时信号波动大，优先挑国内干线做底，避免长距离跨境带来的漂移。',
    rec: ['云岫 · 国内干线', '雪雀 · 欧洲纵深'],
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20editorial%203D%20illustration%20of%20a%20rounded%20smartphone%20floating%20above%20soft%20flowing%20signal%20waves%20with%20small%20glowing%20green%20nodes%20and%20a%20single%20muted%20red%20accent%20point%2C%20warm%20cream%20paper%20background%2C%20clean%20geometric%20shapes%2C%20gentle%20soft%20shadows%2C%20calm%20harmonious%20aesthetic%2C%20high%20detail&width=800&height=600&seq=chigua-scn-mobile-1&orientation=landscape',
  },
  {
    id: 2,
    icon: 'ri-building-4-line',
    title: '校园 / 公共 Wi-Fi',
    tip: '拥堵环境别死磕单线',
    desc: '共享带宽被占满时，需要跨机房做线路对比后再切，绕开高峰期出口拥塞，体验会更顺。',
    rec: ['星野 · 亚太', '长桥 · 北美'],
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20editorial%203D%20scene%20of%20a%20campus%20building%20shape%20emitting%20layered%20signal%20ripples%20toward%20a%20laptop%2C%20with%20dense%20small%20green%20network%20dots%20and%20a%20muted%20red%20hotspot%2C%20warm%20cream%20paper%20background%2C%20clean%20rounded%20geometric%20style%2C%20soft%20shadows%2C%20calm%20aesthetic%2C%20high%20detail&width=800&height=600&seq=chigua-scn-wifi-2&orientation=landscape',
  },
  {
    id: 3,
    icon: 'ri-earth-line',
    title: '跨境 / 跨国访问',
    tip: '看“全程可用性”不看单点速度',
    desc: '访问境外内容时地理距离决定延迟下限，先做路线对比，再结合测速样本选跨境中转更稳妥。',
    rec: ['疾风 · 跨境中转', '长桥 · 北美'],
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20editorial%203D%20illustration%20of%20a%20globe%20with%20curved%20travel%20arcs%20connecting%20several%20bright%20green%20city%20nodes%20across%20the%20surface%2C%20one%20warm%20muted%20red%20terminus%2C%20warm%20cream%20paper%20background%2C%20clean%20geometric%20isometric%20style%2C%20soft%20shadows%2C%20calm%20aesthetic%2C%20high%20detail&width=800&height=600&seq=chigua-scn-globe-3&orientation=landscape',
  },
  {
    id: 4,
    icon: 'ri-moon-line',
    title: '夜间高峰 / 低延迟需求',
    tip: '晚高峰多切一次 更稳',
    desc: '刷剧与联机场景看重稳定不掉线，夜间热门节点易挤，可切备用线并参考本周速度测试再定。',
    rec: ['雪雀 · 欧洲纵深', '云岫 · 国内干线'],
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20editorial%203D%20scene%20of%20a%20quiet%20night%20skyline%20with%20a%20watch%20icon%20and%20low%20latency%20waveform%20line%20glowing%20in%20green%2C%20tiny%20muted%20red%20clock%20hands%2C%20warm%20cream%20paper%20background%2C%20clean%20rounded%20geometric%20style%2C%20soft%20shadows%2C%20calm%20aesthetic%2C%20high%20detail&width=800&height=600&seq=chigua-scn-night-4&orientation=landscape',
  },
];

export const compareRows = [
  { name: '云岫 · 国内干线', type: '国内直连', nodes: 48, lat: '18ms', band: '820M', stay: '99.1%', use: '日常访问 / 移动网络', score: 4.9, badge: '编辑推荐' },
  { name: '星野 · 亚太', type: '跨境轻载', nodes: 31, lat: '39ms', band: '610M', stay: '98.2%', use: '白天跨境 / 校园网', score: 4.7, badge: '白天更好' },
  { name: '长桥 · 北美', type: '跨洋主干', nodes: 22, lat: '146ms', band: '480M', stay: '97.4%', use: '北美内容 / 长连接', score: 4.5, badge: '' },
  { name: '疾风 · 跨境中转', type: '多段转发', nodes: 26, lat: '88ms', band: '540M', stay: '96.8%', use: '跨国访问 / 视频', score: 4.4, badge: '' },
  { name: '雪雀 · 欧洲纵深', type: '欧洲稳定组', nodes: 18, lat: '205ms', band: '410M', stay: '96.1%', use: '欧洲站 / 夜间备用', score: 4.2, badge: '备用之选' },
];

export const speedSamples = [
  { name: '云岫 · 国内干线', latency: 18, bandwidth: 92, delta: '较上周 -4ms' },
  { name: '星野 · 亚太', latency: 39, bandwidth: 78, delta: '较上周 -7ms' },
  { name: '疾风 · 跨境中转', latency: 88, bandwidth: 70, delta: '较上周 +9ms' },
  { name: '长桥 · 北美', latency: 146, bandwidth: 63, delta: '较上周 +2ms' },
  { name: '雪雀 · 欧洲纵深', latency: 205, bandwidth: 54, delta: '较上周 +12ms' },
];

export const timeBuckets = [
  { label: '06–10 时', desc: '清晨空闲，全国线路普遍顺滑' },
  { label: '11–14 时', desc: '午间回升，跨境线偶有抖动' },
  { label: '19–23 时', desc: '晚高峰最挤，建议切备用线' },
  { label: '00–05 时', desc: '凌晨空旷，测速常刷新低值' },
];

export const guideSteps = [
  { step: '01', icon: 'ri-download-2-line', title: '拉取最新线路', desc: '在客户端同步线路库，拿到最新节点与切换指南里的可选清单。' },
  { step: '02', icon: 'ri-sort-asc', title: '做一次线路对比', desc: '按场景匹配 2–3 条候选线，先看可用性再看延迟与带宽数据。' },
  { step: '03', icon: 'ri-exchange-line', title: '一键快速切换', desc: '触发切换后等出口恢复稳定，再进入下一步看是否需要继续换线。' },
  { step: '04', icon: 'ri-speed-up-line', title: '结合速度测试微调', desc: '观察 1–2 分钟，跑一次速度测试参考数据，把那条“哪个好用”的线固定下来。' },
];

export const tips = [
  { icon: 'ri-timer-line', title: '先切底再切远', desc: '卡顿时先回国内干线，再决定要不要上跨境线，避免判断被叠加延迟干扰。' },
  { icon: 'ri-check-double-line', title: '看全程可用性', desc: '单独测一次速度快不代表稳，做线路对比记得多看 24h 可用性曲线。' },
  { icon: 'ri-restart-line', title: '定期刷新样本', desc: '网络拓扑会变，切换指南里的测速参考建议每段时间重新跑一遍。' },
  { icon: 'ri-cpu-line', title: '减少中转跳数', desc: '延迟来自跳数叠加，能用主干直达就别套多层转发，速度测试更漂亮。' },
];

export const faqs = [
  {
    q: '线路到底“哪个好用”？',
    a: '没有绝对答案。好不好用取决于你的网络环境、访问目标和时段。通常先用本文的线路对比锁定候选，再结合速度测试参考里最近一周的样本判断，高峰期前后可能得出不同结论。',
  },
  {
    q: '不同网络环境下切换真的有差别吗？',
    a: '差别明显。移动网络看重弱信号稳定，公共 Wi-Fi 怕出口拥塞，跨境访问吃地理延迟。切换指南会建议按场景匹配线路，而不是所有人共用一条。',
  },
  {
    q: '做多线选择时该看哪些指标？',
    a: '优先级建议：24 小时可用性 &gt; 平均延迟 &gt; 带宽余量。先排除掉不稳定线路，再在剩下几条里用速度测试参考对比，挑更契合的那条。',
  },
  {
    q: '切了线还是慢，问题出在哪？',
    a: '先查三处：当前客户端是否已同步最新线路库、是否误开了多余转发、目标出口此刻是否正处晚高峰。逐项排除后再重新做一次线路对比。',
  },
  {
    q: '这里的测速数据是实时值吗？',
    a: '属于参考样本而非实时值，反映近期整体表现。页面上的速度测试参考用于帮助你判断趋势，精确到毫秒的数值仍需在客户端内实测。',
  },
];

export const heroChips = [
  { label: '可用线路', value: '1,240+' },
  { label: '本周样本', value: '286 万' },
  { label: '覆盖机房', value: '18 城' },
];